export default __webpack_public_path__ + "static/logo-payperks-white-bf7e976bbe2099f78a0cc5ec15a6b9fb.svg";